/**
 * Header class for handling stickyness and height variable
 */
class Header {
  #header;
  #stickyObserver;

  constructor() {
    this.#header = document.querySelector("[data-header-element]");
    this.#stickyObserver = document.querySelector(
      "[data-header-sticky-observer]",
    );

    if (!this.#stickyObserver) {
      this.#stickyObserver = document.querySelector(
        "[data-header-sticky-observer-backup]",
      );
    }
  }

  initialize() {
    if (!this.#header) {
      return;
    }

    this.#observeIfSticky();
  }

  #observeIfSticky() {
    if (!this.#stickyObserver) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // Check if we've scrolled past the observer (top of element is above viewport)
        const hasPassed = entry.boundingClientRect.top < 0;

        // Only add page-scrolled class when not intersecting AND has scrolled past
        document.body.classList.toggle(
          "page-scrolled",
          !entry.isIntersecting && hasPassed,
        );
      });
    });

    observer.observe(this.#stickyObserver);
  }
}

const header = new Header();
header.initialize();
